"use client";

import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { CheckIcon } from "lucide-react";
import { motion } from "motion/react";
import React from "react";
import MotionHighlight from "@/components/effects/MotionHighlight";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuCheckboxItemProps } from "../types";

function DropdownMenuCheckboxItem({
  checked,
  disabled,
  className,
  children,
  ...props
}: DropdownMenuCheckboxItemProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <MotionHighlight.Item disabled={disabled}>
      <Flex.Column asChild justify="center" items="center" gap="gap-2">
        <DropdownMenuPrimitive.CheckboxItem
          {...native}
          asChild
          checked={checked}
          disabled={disabled}
        >
          <motion.div
            data-slot="dropdown-menu-checkbox-item"
            data-disabled={disabled}
            whileTap={{ scale: 0.95 }}
            className={cn(
              "[&:not([data-highlight])]:focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
              className,
              classes,
            )}
          >
            <Flex
              as="span"
              className="pointer-events-none absolute left-2 size-3.5"
              direction="row"
              justify="center"
              items="center"
            >
              <DropdownMenuPrimitive.ItemIndicator data-slot="dropdown-ment-checkbox-item-indicator">
                <CheckIcon className="size-4" />
              </DropdownMenuPrimitive.ItemIndicator>
            </Flex>
            {children}
          </motion.div>
        </DropdownMenuPrimitive.CheckboxItem>
      </Flex.Column>
    </MotionHighlight.Item>
  );
}

DropdownMenuCheckboxItem.displayName = "DropdownMenu.CheckboxItem";

export default DropdownMenuCheckboxItem;
